import image from "../assets/img/404-not-found.png";

export default function NotFound() {
  return (
    <section className="sec-not-found">
      <div className='not-found-image'><img src={image} alt=''/></div>
    </section>
  )
}
